import script from "./Footer.vue?vue&type=script&lang=ts&setup=true&name=footer"
export * from "./Footer.vue?vue&type=script&lang=ts&setup=true&name=footer"

import "./Footer.vue?vue&type=style&index=0&id=ce405414&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce405414"]])

export default __exports__